import React, { FC } from "react";

interface GenericSelectorProps {
  options: { name: string; selected: boolean }[];
  setOptions: React.Dispatch<
    React.SetStateAction<{ name: string; selected: boolean }[]>
  >;
}

const GenericSelector: FC<GenericSelectorProps> = ({ options, setOptions }) => {
  const handleOptionClick = (selectedOption: {
    name: string;
    selected: boolean;
  }) => {
    const updatedOptions = options.map((option) =>
      option.name === selectedOption.name
        ? { ...option, selected: true }
        : { ...option, selected: false },
    );
    setOptions(updatedOptions);
  };

  return (
    <div className="flex  w-full bg-black border border-white/20 rounded-md overflow-clip text-sm sm:text-base font-semibold transition-all">
      {options.map((option, index) => (
        <button
          key={index}
          className={`px-4 py-1 w-full transition-all border-white/20 ${
            index !== 0 && `border-l`
          }   ${
            option.selected
              ? "bg-orange-400/90 text-white"
              : `text-white/50 hover:bg-zinc-900 hover:text-gray-50`
          }`}
          onClick={() => handleOptionClick(option)}
        >
          {option.name}
        </button>
      ))}
    </div>
  );
};

export default GenericSelector;
